import { WorkspaceInvitation } from '@rentguru/commons-utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useCallback } from 'react';

import { fetchOrganizationInvitations } from 'src/auth/client';
import { useUser } from 'src/hooks/UserContext';

export const workspaceInvitationsQueryKey = (clientId: string | null | undefined) =>
  ['workspace-invitations', clientId ?? null] as const;

const WORKSPACE_INVITATIONS_STALE_TIME_MS = 30_000;

export const useWorkspaceInvitations = () => {
  const queryClient = useQueryClient();
  const { clientId } = useUser();

  const { data: invitations, isLoading } = useQuery<WorkspaceInvitation[]>({
    queryKey: workspaceInvitationsQueryKey(clientId),
    queryFn: fetchOrganizationInvitations,
    staleTime: WORKSPACE_INVITATIONS_STALE_TIME_MS,
    enabled: !isNil(clientId),
  });

  const refresh = useCallback(
    () => queryClient.invalidateQueries({ queryKey: workspaceInvitationsQueryKey(clientId) }),
    [queryClient, clientId]
  );

  return { invitations: invitations ?? [], loading: isLoading, refresh };
};
